import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import toast from 'react-hot-toast';
import { LogIn, Mail, Lock, RefreshCw } from 'lucide-react';
import InstalarApp from './InstalarApp'; // PLENARIUM:INSTALAR_APP

export default function LoginAdmin() {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const [limpando, setLimpando] = useState(false);
  const { loginAdmin } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await loginAdmin(email, senha);
      navigate('/');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Erro ao fazer login');
    } finally {
      setLoading(false);
    }
  };

  const limparCache = async () => {
    setLimpando(true);
    try {
      // Remove todos os service workers
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (const reg of registrations) await reg.unregister();
      }
      // Limpa todos os caches
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map(name => caches.delete(name)));
      }
      toast.success('Cache limpo! Recarregando...');
      setTimeout(() => window.location.reload(true), 1000);
    } catch {
      toast.error('Erro ao limpar cache');
      setLimpando(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <div className="login-logo">
          <div style={{ marginBottom: 8 }}>
            <img src="/logo512.png" alt="Plenarium Digital" style={{ width: 80, height: 80, objectFit: 'contain' }} />
          </div>          <h1>Plenarium Digital</h1>
          <p>Painel Administrativo</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label"><Mail size={12} style={{display:'inline',marginRight:4}}/>E-mail</label>
            <input className="form-input" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="admin@camara.am.gov.br" required />
          </div>
          <div className="form-group">
            <label className="form-label"><Lock size={12} style={{display:'inline',marginRight:4}}/>Senha</label>
            <input className="form-input" type="password" value={senha} onChange={e => setSenha(e.target.value)} placeholder="••••••••" required />
          </div>
          <button className="btn btn-primary" style={{width:'100%', justifyContent:'center', marginTop:8}} type="submit" disabled={loading}>
            <LogIn size={16}/> {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
        <p style={{textAlign:'center', marginTop:16, fontSize:'0.85rem', color:'var(--texto-suave)'}}>
          Vereador? <Link to="/login/vereador" style={{color:'var(--verde)', fontWeight:600}}>Acesse aqui</Link>
        </p>
        <InstalarApp />{/* PLENARIUM:INSTALAR_APP */}
        <div style={{borderTop:'1px solid var(--cinza)', marginTop:20, paddingTop:16, textAlign:'center'}}>
          <p style={{fontSize:'0.75rem', color:'var(--texto-suave)', marginBottom:8}}>
            Tela em branco ou sistema não carrega?
          </p>
          <button
            onClick={limparCache}
            disabled={limpando}
            style={{background:'none', border:'1px solid var(--cinza)', borderRadius:8, padding:'6px 14px', cursor:'pointer', fontSize:'0.78rem', color:'var(--texto-suave)', display:'inline-flex', alignItems:'center', gap:6}}
          >
            <RefreshCw size={13} /> {limpando ? 'Limpando...' : 'Limpar cache e recarregar'}
          </button>
        </div>
      </div>
    </div>
  );
}